import React, {useEffect, useState} from 'react';
import TitleMain from "../../components/Title/TitleMain";
import Planning from "../../components/Planning/Planning";
import {
    getSeancesPlanningApi,
    getSeancesPlanningLocal, parseSeancesPlanning,
    parseSeancesPlanningAdmin, parseSeancesPlanningCoach
} from "../../services/PlanningService";
import {useUser} from "../../contexts/UserContext";
import AxiosConfig from "../../services/AxiosConfig";
import {isAdmin} from "../../services/RoleService";

const PlanningMainPage = props => {
    const [planningData, setPlanningData] = useState({ events: [], legend: [] });
    const { user } = useUser();

    const myPlanningDataParse = isAdmin(user) ?
        parseSeancesPlanningAdmin(planningData.seances)
        : planningData;

    const chargerDonnees = async (start, end) => {
        const response = await getSeancesPlanningApi(start, end);
        setPlanningData(response.planning);
    };

    return (
        <div className="content">
            <TitleMain text="Planning"/>
            { planningData && <Planning
                events={ isAdmin(user) ?
                    myPlanningDataParse.events
                    : user.roles.includes("ROLE_COACH") ?
                        parseSeancesPlanningCoach(planningData.seances).events
                        : parseSeancesPlanning(planningData.seances).events}
                height={"500px"}
                legend={myPlanningDataParse.legend}
                onDatesChange={chargerDonnees}
            /> }
        </div>
    );
};

export default PlanningMainPage;
